import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/lottery/record/list'
    return request.post(url,data)
}

export function all() {
    let url = '/lottery/record/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/lottery/record/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/lottery/record/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/lottery/record/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/lottery/record/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/lottery/record/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/lottery/record/dmz/options'
    return request.get(url)
}
